// @flow
import React, {useState} from 'react';
import TextInput from '../GUI_COMMON/COMPONENTS/TextInput';
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import ArchiverClientApi from "../API/archiverClientApi";
import Popup from "../GUI_COMMON/COMPONENTS/Popup";
import ErrorPopup from "../GUI_COMMON/COMPONENTS/ErrorPopup";
import LIButton from "../GUI_COMMON/COMPONENTS/LIButton";
import PropTypes from "prop-types";

const ReprintBoxLabelsForm = ({destinationPrinterDevice}) => {
    
    const [isPrinting, setIsPrinting] = useState(false);
    const [goodNess, setGoodness] = useState("bad");
    const [barcode, setBarcode] = useState("");
    
    function handleBoxBarcodeChanged(e) {
        const rawStr:string = filterBadChars(e.target.value);

        setBarcode(rawStr.toUpperCase());
        setGoodness(LIUtils.boxBarcodeHasGoodFormat(rawStr)?"good":"bad");
    }
    
    function filterBadChars(value:string) {
        // check for a bad characer
        const re=new RegExp('[^0-9a-zA-Z.+-]');
        if(re.test(value)) { // bad character -- ignore
            console.log("ignoring bad sample # character");
            return barcode;  // no change
        }
        return value;  // return new value
    }

    function printerIsValid() {
        return destinationPrinterDevice && destinationPrinterDevice.id > 0;
    }
    
    function formIsValid() {
       return LIUtils.boxBarcodeHasGoodFormat(barcode) && printerIsValid();
    }
    
    function onSubmit() {
        setIsPrinting(true);

        ArchiverClientApi.sendReprintLabelsRequest(destinationPrinterDevice.id, barcode, true)
        .then( (response) => {
            const msg = `<p>Printing of the box label '${barcode}' should be under way now on printer '${destinationPrinterDevice.fullName}'.</p>`;
            Popup.showInfo(msg);
        })
        .catch( errorResponse => ErrorPopup.showError("Print Failed",errorResponse.error))
        .finally( () => {
                setIsPrinting(false);
            });
    }
    
    return (
        <form id="reprintLabelsForm">
           
            <div className="card border-0">
                <h2>Reprint A Box Label</h2>
                <p>Use this to reprint a barcode label for a single box.</p> 
                <ul className="card li-bg-blue-card">
                    <li>Note that an initial box label is always printed when an entire box of labels is printed using 
                            the <a href="#printLabelsForm">Print New Labels</a> activity above.
                    </li>
                </ul>
                <div className="row">
                    <div className="col-5">
                        <TextInput name="barcode" label="Box Barcode" onChange={handleBoxBarcodeChanged}
                                   goodNess={goodNess}
                                   placeholder="YY<nuemonic>.####"
                                   value={barcode}
                                   required/>
                    </div>
                </div>
                
            </div>
            
            <div className="row justify-content-center">
                <LIButton bgClass="mx-5 my-5" large primary onClick={onSubmit} disabled={!formIsValid()}
                          label="Reprint Box Label" showBusy={isPrinting}/>
            </div>
        </form>
    );
};

ReprintBoxLabelsForm.propTypes = {
    destinationPrinterDevice: PropTypes.object.isRequired
};

export default ReprintBoxLabelsForm;